/**
 * Helper eventi Meta Pixel. Unico punto d'ingresso per gli eventi di
 * conversione (CompleteRegistration, Purchase, …): se il pixel non è attivo
 * (consenso profilazione negato, pixel spento da admin o revocato) window.fbq
 * non esiste e la chiamata è un no-op silenzioso — i chiamanti non devono
 * conoscere lo stato del consenso.
 */

export type FbqFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: FbqFunction;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}

export function trackMetaPixelEvent(event: string, params?: Record<string, unknown>): void {
  const fbq = window.fbq;
  if (typeof fbq !== 'function') return;
  if (params) {
    fbq('track', event, params);
  } else {
    fbq('track', event);
  }
}
